export const LEGAL_PRIVACY_POLICY_HEADING: string = `

<center>
 <h1 style="margin-bottom: 0">Privacy Policy</h1>
 Your Data Privacy Rights
</center>

---

## Privacy Policy

*Also Referred to as “Datenschutzerklärung” in German Law*
*Effective as November 19, 2024, and Last updated November 19, 2024*
`;
